var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"pb-4"},[_c('my-profile-form-payment-options')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }